module.exports = __webpack_public_path__ + "media/how_does_sharing_work/hammer_spanner-5e48faf1.svg";